import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query/react';
import { v2Api } from '~/api/v2/v2Api';
import {
  alertReducer,
  authTokensReducer,
  bannerReducer,
  currentUserReducer,
  modalReducer,
  pageTabsReducer,
  userSessionReducer,
} from '~/redux/slices';

const store = configureStore({
  reducer: {
    authTokens: authTokensReducer,
    userSession: userSessionReducer,
    currentUser: currentUserReducer,
    alert: alertReducer,
    modal: modalReducer,
    banner: bannerReducer,
    pageTabs: pageTabsReducer,
    [v2Api.reducerPath]: v2Api.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(v2Api.middleware),
});

setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
